import { CSSResult, css } from 'lit'
import { csSpacing } from '@cloudsuite/mosaic-shared/styles/spacing.style.js'
import { csColorAction, csColorBackground } from '@cloudsuite/mosaic-shared/styles/colors.style.js'

export const clickThroughMenuStyle = {
  minHeight: css`var(--csc-click-through-menu-min-height, 300px)`,
  backgroundColor: css`var(--csc-click-through-menu-background-color, ${csColorBackground.primary})`,
  columnGap: css`var(--csc-click-through-menu-column-gap, ${csSpacing.spacing08})`,
  rowGap: css`var(--csc-click-through-menu-row-gap, ${csSpacing.spacing05})`,
  containerPadding: css`var(--csc-click-through-menu-container-padding, ${csSpacing.spacing08})`,
  breadcrumbsGap: css`var(--csc-click-through-menu-breadcrumbs-gap, ${csSpacing.spacing04})`,
  breadcrumbsColor: css`var(--csc-click-through-menu-breadcrumbs-color, ${csColorAction.linkSecondary})`,
  breadcrumbsFontWeight: css`var(--csc-click-through-menu-breadcrumbs-font-weight, 700)`,
  columns: css`var(--csc-click-through-menu-columns, 4)`,
  imageWidth: css`var(--csc-click-through-menu-image-width, 150px)`,
  imageAspectRatio: css`var(--csc-click-through-menu-image-aspect-ratio, 1 / 1)`
}

export const style: CSSResult = css`
  :host {
    display: block;
  }

  .container {
    gap: ${csSpacing.spacing08};
    min-height: ${clickThroughMenuStyle.minHeight};
    display: flex;
    flex-direction: column;
    background-color: ${clickThroughMenuStyle.backgroundColor};
    padding: ${clickThroughMenuStyle.containerPadding};
  }

  /* Sidebar Layout */
  .container.sidebar-layout {
    flex-direction: row;
    align-items: flex-start;
    height: 100%;
    padding: 0;
  }

  .container.sidebar-layout .wrapper.main-content {
    padding: ${clickThroughMenuStyle.containerPadding} ${clickThroughMenuStyle.containerPadding} ${clickThroughMenuStyle.containerPadding} 0;
  }

  .wrapper {
    display: flex;
    flex-direction: column;
    gap: ${csSpacing.spacing08};
    flex-grow: 1;
    position: relative;
    overflow: hidden;
    background-color: ${clickThroughMenuStyle.backgroundColor};
  }

  .content {
    display: flex;
    gap: ${csSpacing.spacing08};
  }

  .main {
    display: flex;
    flex-direction: column;
    gap: ${csSpacing.spacing08};
    flex-grow: 1;
    min-width: 0;
  }

  .grid-menu {
    overflow-y: auto;
    position: relative;
  }

  .image-wrapper {
    display: flex;
    flex-shrink: 0;
    padding-inline: ${csSpacing.spacing06};
  }

  .image-wrapper cse-image {
    --cse-image-aspect-ratio: ${clickThroughMenuStyle.imageAspectRatio};

    display: block;
    width: ${clickThroughMenuStyle.imageWidth};
  }

  .grid-items-container.grid-layout {
    display: grid;
    column-gap: ${clickThroughMenuStyle.columnGap};
    row-gap: ${clickThroughMenuStyle.rowGap};
  }

  .horizontal {
    grid-template-columns: repeat(${clickThroughMenuStyle.columns}, 1fr);
    grid-auto-flow: row;
  }

  .vertical {
    grid-template-rows: repeat(${clickThroughMenuStyle.columns}, 1fr);
    grid-auto-flow: column;
  }

  .all-category-link-wrapper {
    display: flex;
    width: 100%;
  }

  .all-category-link-wrapper.top-left,
  .all-category-link-wrapper.bottom-left {
    justify-content: flex-start;
  }

  .all-category-link-wrapper.top-right,
  .all-category-link-wrapper.bottom-right {
    justify-content: flex-end;
  }

  .breadcrumb-path {
    --cs-font-body-font-weight: ${clickThroughMenuStyle.breadcrumbsFontWeight};
    --cs-color-text-body: ${clickThroughMenuStyle.breadcrumbsColor};

    display: flex;
    align-items: baseline;
    gap: ${clickThroughMenuStyle.breadcrumbsGap};
  }

  .breadcrumb-link {
    --cse-link-text-decoration-line: none;
  }

  .breadcrumb-separator {
    font-weight: ${clickThroughMenuStyle.breadcrumbsFontWeight};
    color: ${clickThroughMenuStyle.breadcrumbsColor};
  }

  .back-navigation-section {
    display: flex;
    flex-direction: column;
    gap: ${csSpacing.spacing05};
  }
`
